import { createUseStyles } from 'react-jss';

const styles = {
  usersWrapper: {
    marginBottom: '2rem',
  },
};

const createStyles = createUseStyles(styles);

export { createStyles };
